import './ads.scss'

export const Ads = () => {
    return (
        <div>
            <div className="back_color">
                <div>
                    <h2>Introducing Instagram Ad Campaigns</h2>
                    <img src="https://eep.io/images/yzco4xsimv0y/3cBiZ2jerucisccksQoMgk/ee450c26a3838e3fc83967ad36e8ff6a/hero-image-for-introducing-instagram-ad-campaigns.jpg?w=1960&fm=webp&q=80" alt="insta_pic" />

                    
                </div>
            </div>

            <div>
                <div className='width_all , margins'>
                    <p style={{marginTop: "50px"}} className='Big_initial'>We’re always looking for new ways to make powerful marketing tools more accessible to our customers. A few months ago, we announced Facebook Ad Campaigns. Today we’re proud to introduce another channel: Instagram Ad Campaigns, an easy way for e-commerce businesses to build their brand and sell more stuff.
                        <br />
                        <br />
                        You can create, manage, and track your email marketing, Facebook ads, and Instagram ads in one place—without any additional fees from us.
                        <br />
                        <br />
                        Why Instagram? It’s a great place to showcase your products and create excitement around your brand. John Foreman, our VP of Product Management, puts it this way: “Mailchimp’s e-commerce customers already spend a lot of time and effort making sure their brand and product photography is on point. Now you can use those beautiful images to bring in customers."
                    </p>

                    <img src="https://eep.io/images/yzco4xsimv0y/3tUE09165yKye6qAqyoC2M/149a9bc7fb3f8c496a80c1d2bcfa313e/image-in-introducing-instagram-ad-campaigns.gif?w=980&fm=webp&q=80"
                        alt='pic' />
                </div>
            </div>
            <div>
                <div className='width_all , margins'>
                    <h2 className='font_size'>Find your people</h2>
                    <p>The real benefit of using Instagram ads in Mailchimp is that you can unlock the power of your Mailchimp list. You already know who your best customers are, so this is a perfect starting place to find new customers who have similar interests or demographics. By targeting people who look like your top customer segments from your Mailchimp contacts, you can find and attract precisely the right audience.</p>
                    <img src="https://eep.io/images/yzco4xsimv0y/43HVZfRoEwEaOQQIAg6Sw0/a367d4cc4fbbd8c61a6b7a6ad64cbb55/image-in-introducing-instagram-ad-campaigns.gif?w=980&fm=webp&q=80" alt="find image" />
                </div>
            </div>
            <div>
                <div className='width_all , margins'>
                    <h2 className='font_size'>Bolster your ROI</h2>
                    <p>
                        One of the hardest parts of marketing your business is the feeling of throwing money into a black hole. With Instagram Ads in Mailchimp, you can see exactly how your ads are performing.
                        <br />
                        "Advertising on Instagram gives our e-commerce customers the best of both worlds—an easier way to find new customers by targeting people like the ones on your list and specifics about what items were actually sold," says Tom Klein, our CMO.
                        <br />
                        When you connect your store to Mailchimp, you’ll be able to see the total return of your Instagram ad, including items sold, subscribers added, and customers acquired.
                    </p>
                    <img src='https://eep.io/images/yzco4xsimv0y/6ylBUK7sWcumW2iuoYcUSc/4123293af53b33d4f06644c849ab6424/image-in-introducing-instagram-ad-campaigns.gif?w=980&fm=webp&q=80' alt='bolster_image' />
                </div>
            </div>

            <div>
                <div className='width_all , margins'>
                    <h2 className='font_size'>Create your ad</h2>
                    <p>If building an ad sounds daunting, don’t worry! It’s the same experience you already know and love. If you can build an email campaign, then you can create an Instagram ad. (You can do it at the same time you build your Facebook ads, too.)
                    <br/>
                        “Instagram Ad Campaigns are just as easy to build inside Mailchimp as Facebook ads are,” says John. “Our ad builder streamlines ad creation, precision targeting, and reporting so that time-strapped e-comm companies can get an ad out quickly to build their audience and drive traffic to their store in a measurable way.”
                        <br/>
                        Instagram ads are now live for everyone, so check them out!</p>
                </div>
            </div>

            <div id="footer">
                <div id="footer_inside">
                    <div>
                        <h3>Projects</h3>
                        <p class="small_font">Why Mailchimp</p>
                        <p class="small_font">Product updates</p>
                        <p class="small_font">Email Marketing</p>
                        <p class="small_font">Website</p>
                    </div>
                    <div>
                        <h3>
                            Resources
                        </h3>
                        <p class="small_font">Guide and Tutorials</p>
                        <p class="small_font">Marketing Tips</p>
                        <p class="small_font">Free marketing tools</p>
                        <p class="small_font">Marketing Glossary</p>
                    </div>
                    <div>
                        <h3>Community</h3>
                        <p class="small_font">Agencies and Freelancers</p>
                        <p class="small_font">Developers</p>
                        <p class="small_font">Events</p>
                    </div>
                    <div>
                        <h3>Company</h3>
                        <p class="small_font">Our Stories</p>
                        <p class="small_font">NewsRooms</p>
                        <p class="small_font">Annual Reports</p>
                        <p class="small_font"></p>
                    </div>
                    <div>
                        <div>
                            <img src="https://eep.io/images/yzco4xsimv0y/73ZAoe8O3Y7SXQLeCNTq5u/8ddf1f63b4abdf7f67149d3a9d74a0bd/MCP.svg?w=260&fm=webp&q=80"
                                className='small_image' />
                            {/* style="width:150px" */}
                            <p class="small_font">Films, podcasts, and original series that celebrate the entrepreneurial spirit.</p>
                            <p class="small_font" style={{ marginBottom: "40px" }}>Check it out</p>
                        </div>
                        <div>
                            <img src="https://eep.io/images/yzco4xsimv0y/5itQmdXHB6vMuAcvyWp5MR/ef5cd2cecd4c92b7029a22ec67585c65/Courier.svg?w=260&fm=webp&q=80"
                                className='small_image' />
                            {/*  style="width:130px; margin-top: 50px;" */}
                            <p class="small_font">Expert insights, industry trends, and inspiring stories that help you live and work on
                                your own terms.</p>
                            <p class="small_font">Learn more</p>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    )
}